// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const getCompanyTagsApi = (companyId) =>
  api().get(`/tags?company_id=${companyId}&is_active=true`);

export default getCompanyTagsApi;
